import { Component, OnInit } from '@angular/core';
import { AuthResponse, AuthService, RegisterCredentials } from '../auth.service';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';

@Component({
    selector: 'register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.css'],
    standalone: false
})
export class RegisterComponent implements OnInit {

  credential: RegisterCredentials;
  show: boolean = false;
  show2: boolean = false;

  constructor(private authService: AuthService, private router: Router) {

  }

  toggle() {
    if (this.show) {
      this.show = false;
    } else {
      this.show = true;
    }

  }


  toggle2() {
    if (this.show2) {
      this.show2 = false;
    } else {
      this.show2 = true;
    }
  }

  initValues() {

    this.credential = {
      username: '',
      password: '',
      confirmPassword: '',
      role: 'user',
      email: ''
    }

  }
  openLoginDialog() {
    this.router.navigate(['/']);
    this.authService.openLoginDialog();
  }


  async register(form: NgForm) {
    let values: RegisterCredentials = {

      username: form.value.username as string,
      password: form.value.password as string,
      confirmPassword: form.value.confirmPassword as string,
      email: form.value.email as string,
      role: 'user'
    }


    let response: AuthResponse = await this.authService.register(values);
    if (response) {

      //this.authService.storeAuthToken(response);
      this.authService.updateAuthState(response);
      this.authService.openSnackBar('Registration complete', '');
      this.router.navigate(['/']);
      this.initValues();
      form.reset();
      return;
    }
    this.authService.openSnackBar('There was an issue registering', 'Please try again');
  }

  ngOnInit(): void {
    this.initValues();
  }

}
